import CircleSvg from '@assets/images/svg/circle.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleIconProps {
    size?: number;
    color?: string;
}

export const CircleIcon = React.memo<CircleIconProps>(function CircleIcon({
    size = 12,
    color = '#666666',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleSvg width={size} height={size} color={color} />
        </View>
    );
});

export default CircleIcon;